'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useRef, useState } from 'react';
import { getInstanceClient } from '../../../../di/entry.browser.js';
import { CouponStoreContext } from './CouponStoreContext.js';
/**
 * Provides the coupon store to the component tree.
 * The store will be created for every HTTP request to the server to avoid caching of sensitive data.
 * The store will used for the lifetime of the application in the browser.
 *
 * @param root0 The component props
 * @param root0.children The children components to render
 * @param root0.moduleEngine The module engine name
 * @param root0.preloadedState The preloaded state to hydrate the store with
 * @returns Coupon store provider component
 */
export function CouponStoreProvider({ children, moduleEngine, preloadedState }) {
    const couponRepository = getInstanceClient('ICouponZustandStoreService');
    const storeRef = useRef(undefined);
    const [store, setStore] = useState(undefined);
    useEffect(() => {
        storeRef.current ??= couponRepository.bootstrap(moduleEngine, preloadedState);
        setStore(storeRef.current);
    }, [couponRepository, moduleEngine, preloadedState]);
    // TODO: create a new component that is in charge of creating a new coupon when a draw is added
    // Can also be used to remove outdated coupons - redirect user to start page if so
    if (!store) {
        return undefined;
    }
    return _jsx(CouponStoreContext.Provider, { value: store, children: children });
}
//# sourceMappingURL=CouponStoreProvider.js.map